module.exports = __webpack_public_path__ + "images/6fa3bd1c39532a97c8dc4908e0cd82ea2a354e88845dd5a97240521bf55eb540.svg";